package app.properties

import kotlinx.html.HEADER
import org.w3c.dom.get
import kotlin.browser.localStorage
import kotlin.browser.window
import kotlin.js.Promise

var uuid = kotlinext.js.require("uuid-random")

val React: dynamic = kotlinext.js.require("react")
val ReactDOM: dynamic = kotlinext.js.require("react-dom")

fun getTargetValue(e: dynamic) : String {
    val value = if(e.target.type == "checkbox")  e.target.checked else e.target.value
    return value.toString()
}

fun getTargetValueToInt(e: dynamic) : Int? {
    val value : String = if(e.target.type == "checkbox")  e.target.checked else e.target.value
    return try {
        value.toInt()
    } catch (e: NumberFormatException) {
        null
    }
}

fun pow(base: Double, exp: Double) : Double = js("Math.pow(base, exp)")

interface AxiosRequest {
    val data: dynamic
    val status: Int
    val statusText: String
    val headers: dynamic
    val config: dynamic
    val request: dynamic
}

fun axiosGet(url: String,
             header: String = "{\"Authorization\": \"${localStorage["jwt"] ?: ""}\", \"Access-Control-Allow-Origin\": \"*\"}"
) : Promise<AxiosRequest> = js("axios.get(url, {headers: JSON.parse(header)})")

fun axiosPost(url: String, data: Any, header: String = "{\"Authorization\": \"${localStorage["jwt"] ?: ""}\", \"Access-Control-Allow-Origin\": \"*\"}") : Promise<AxiosRequest> = js("""
        if(header["Authorization"] != "") {
            axios.post(url, data, {
                headers: JSON.parse(header)
            })
        } else {
            axios.post(url, data)
        }
    """)

fun chackLogin() {
    if (localStorage["jwt"]==null && localStorage["jwt"]=="") {
       window.location.assign("/admin")
    }
}

fun setTimeOut(time: Long, f: () -> Unit) = js("setTimeout(f, time)")

fun phoneMask(f: (String, Int) -> Unit) = js("""jQuery('.phone').mask('+374 (99) 99-99-99',{completed:function(){ f(this.val(), this.data('phone-index')) }});""")

external fun PNotify(obj: dynamic)